<template>
  <div :class="{ 'border px-9 pt-10': !isDrawerUse }" class="rounded-lg">
    <div class="py-2">
      <!-- The id in the next line maps the walkthrough to that div element. Please do not remove this id -->
      <div
        class="border-b text-base font-bold text-root-2 mt-5 mb-2"
        id="cardsTourItem2"
      >
        Create Card
      </div>
      <el-form
        label-position="top"
        :model="cardDetailsForm"
        label-width="80px"
        size="normal"
      >
        <el-form-item label="First Name" prop="firstName">
          <el-input
            name="firstName"
            class="rounded-lg"
            placeholder="Enter Name"
            type="text"
            v-model="cardDetailsForm.firstName"
          ></el-input>
        </el-form-item>
        <el-form-item label="Last Name" prop="lastName">
          <el-input
            name="lastName"
            class="rounded-lg"
            placeholder="Enter Name"
            type="text"
            v-model="cardDetailsForm.lastName"
          ></el-input>
        </el-form-item>
        <div class="flex flex-col md:flex-row w-full">
          <el-form-item
            class="text-root-2 mr-1 w-full md:w-1/2"
            label="Select ID Type"
            prop="IdType"
          >
            <el-select
              name="Select ID Type "
              class="rounded-lg w-full"
              placeholder="Select ID Type"
              type="text"
              v-model="cardDetailsForm.IdType"
            ></el-select>
          </el-form-item>

          <el-form-item
            class="text-root-2 ml-1 w-full md:w-1/2"
            label="Identification Number of ID "
            prop="idNumber"
          >
            <el-input
              name="idNumber"
              class="rounded-lg"
              placeholder="Enter ID Number"
              type="number"
              v-model.trim="cardDetailsForm.idNumber"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="Upload ID Image" prop="idUpload">
          <el-input
            accept=".jpg,.jpeg,.png,.pdf,.docx,.doc"
            placeholder="Upload Document"
            v-model="cardDetailsForm.documentUpload"
          >
            <span
              slot="suffix"
              class="flex items-center justify-center py-3 px-4 absolute right-0 cursor-pointer fg-on-disabled rounded-lg z-0"
            >
              <span><white-cloud-icon /></span>
              <span
                class="text-white text-xs mr-2 ml-2 whitespace-nowrap font-medium"
                >File Upload</span
              >
            </span></el-input
          >
        </el-form-item>

        <el-form-item label="Card Name" prop="cardName">
          <el-input
            name="cardName"
            class="rounded-lg"
            placeholder="Enter Card Name"
            type="text"
            v-model="cardDetailsForm.cardName"
          ></el-input>
        </el-form-item>
        <div class="flex justify-end">
          <el-button
            @click="saveFormData"
            class="w-full bg-primary cursor-pointer rounded-lg py-4 flex justify-center items-center text-white font-normal"
          >
            Continue
          </el-button>
        </div>
      </el-form>
    </div>
    <app-tour
      :tourDetails="cardsTour"
      tourComponent="card"
      :displayTour="displayTour"
      @stopTour="stopTour"
    />
  </div>
</template>

<script>
import { ValidateInput } from '@/utils/helpers'
import { CARDS_TOUR } from '@/utils/constants'
export default {
  components: {
    AppTour: () => import('@/components/v2/app-tour/AppTour.vue'),
    WhiteCloudIcon: () => import('@/assets/v2/icons/WhiteCloudIcon.vue')
  },
  props: {
    isDrawerUse: {
      type: Boolean,
      default: () => false
    }
  },
  emits: ['updateCurrentStep'],
  data () {
    return {
      displayTour: false,
      cardsTour: CARDS_TOUR,
      cardDetailsForm: {
        firstName: '',
        lastName: '',
        cardName: '',
        idUpload: '',
        IdType: '',
        idNumber: '',
        documentUpload: ''
      },
      rules: {
        firstName: [
          {
            message: 'Please input first name',
            trigger: ['blur', 'change']
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        lastName: [
          {
            message: 'Please input last name',
            trigger: ['blur', 'change']
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        cardName: [
          {
            message: 'Please input last name',
            trigger: ['blur', 'change']
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    startCardsTour () {
      this.$tours.cardsTour.start(1)
      this.displayTour = true
    },
    stopTour () {
      this.displayTour = false
      this.$store.dispatch('appTour/startCardsTourTwo', false)
    },
    saveFormData () {
      this.$emit('updateCurrentStep', 2)
    }
  },
  mounted () {
    if (this.$store.state.appTour.startCardsTourTwo) {
      setTimeout(() => {
        this.startCardsTour()
      }, 10)
    }
  }
}
</script>

<style lang="scss" scoped></style>
